import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const refreshApproval = async (data: any) => {
	const URL = `${API_URL}GetRefreshmentAllowancesByOrganisationID`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		refreshApprovalToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const calculateRefreshment = async (data: any) => {
	const URL = `${API_URL}CalculateRefreshmentAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		calculateRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const approveRefreshment = async (data: any) => {
	const URL = `${API_URL}ApproveRefreshmentAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		approveRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const bulkApproveRefreshment = async (data: any) => {
	const URL = `${API_URL}BulkApproveRefreshmentAllowances`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		bulkApproveRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const rejectRefreshment = async (data: any) => {
	const URL = `${API_URL}RejectRefreshmentAllowance`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	const requestData = {
		rejectRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};
